import { DCRecord } from "@/@types/lib/dataController";
import api from "../lib/api";

export interface IDijeloviService {
  partiallyUpdateDio: (objektId: number, katId: number, dioId: number, data: any) => Promise<any>;
}

const dijeloviService: IDijeloviService = {
  partiallyUpdateDio
};

function partiallyUpdateDio(objektId: number, katId: number, dioId: number, data: any) {
  const apiInstance = new api();
  const url = `operations/objekti/${objektId}/katovi/${katId}/dijelovi/${dioId}`;

  return apiInstance.Call(url, "patch", data);
}

export default dijeloviService;